export function checkIfLoggedIn(logonUrl: string, method?: string) {
	let logon = logonUrl;
	if (logon && logon.length > 0) {
		if (method) {
			logon = logon.replace('*method*', method);
		}

		alert(Prompts.MustLogin);
		window.location.href = logon;
		return false;
	}

	return true;
}

export function executeIfLoggedIn(action: () => void, logonUrl: string, method?: string) {
	if (checkIfLoggedIn(logonUrl, method)) {
		action();
	}
}

export async function executeIfLoggedInAsync<TResult>(
	action: () => Promise<TResult>,
	logonUrl: string,
	method?: string
): Promise<TResult> {
	if (checkIfLoggedIn(logonUrl, method)) {
		return action();
	} else {
		return null;
	}
}
